import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { PATH_DASHBOARD } from "../../routes/paths";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  types: [],
};

export const createType = createAsyncThunk(
  "createType/type",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("types", data);
      enqueueSnackbar("Type is added successfully");
      navigate(PATH_DASHBOARD.entries.types.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchTypes = createAsyncThunk(
  "fetchTypes/types",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`types`);

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);


export const updateType = createAsyncThunk(
  "updateType/type",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`types/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteType = createAsyncThunk(
  "deleteType/type",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`types/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const typesSlice = createSlice({
  name: "types",
  initialState,
  extraReducers: (builder) => {

     // TODO: create size
        builder.addCase(createType.pending, (state, _) => {
          state.isLoading = true;
        });
    
        builder.addCase(createType.fulfilled, (state) => {
          state.isLoading = false;
        });
    
        builder.addCase(createType.rejected, (state, action) => {
          state.isLoading = false;
          action.payload.enqueueSnackbar(action.payload.error.message, {
            variant: "error",
          });
        });



    // TODO: fetch types
    builder.addCase(fetchTypes.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchTypes.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.types = action.payload;
    });

    builder.addCase(fetchTypes.rejected, (state, action) => {
      state.fetchLoading = false;
      // action.payload.enqueueSnackbar(action.payload.error.message, {
      //   variant: "error",
      // });
    });

    // ==========================

     // TODO: update type
        builder.addCase(updateType.pending, (state, _) => {
          state.isLoading = true;
        });
    
        builder.addCase(updateType.fulfilled, (state, action) => {
          state.isLoading = false;
          action.payload.enqueueSnackbar("Type is updated successfully");
          state.types.data = state.types.data.map((type) =>
            type.id === action.payload.slug ? action.payload.data : type
          );
          action.payload.setOpenEdit(false);
        });
    
        builder.addCase(updateType.rejected, (state, action) => {
          state.isLoading = false;
          action.payload.enqueueSnackbar(action.payload.error.message, {
            variant: "error",
          });
        });
    
        // ==========================
    
        // TODO: delete type
        builder.addCase(deleteType.pending, (state, _) => {
          state.isLoading = true;
        });
    
        builder.addCase(deleteType.fulfilled, (state, action) => {
          state.isLoading = false;
          state.types.data = state.types.data.filter(
            (size) => size.id !== action.payload.id
          );
          action.payload.enqueueSnackbar("Type is deleted successfully");
        });
    
        builder.addCase(deleteType.rejected, (state, action) => {
          state.isLoading = false;
          action.payload.enqueueSnackbar(action.payload.error.message, {
            variant: "error",
          });
        });
    
  },
});

export default typesSlice.reducer;
